import { render, staticRenderFns } from "./waf-strategy.vue?vue&type=template&id=45a7aa2d&"
import script from "./waf-strategy.vue?vue&type=script&lang=js&"
export * from "./waf-strategy.vue?vue&type=script&lang=js&"
import style0 from "./waf-strategy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports